<template>
  <div class="container-filho" style="margin-top: 20px;">
    <p class="p--acessoRapido__titulo">{{ titulo }}</p>
    <carousel :items-to-show="perPage">
      <slide v-for="(card, index) in listaCards" :key="index">
        <div class="slide__item">
          <div class="box-image--acessoRapido" @click="acessar(card.link)">
            <img class="slide__img--acessoRapido" :src="imageUrl(card.image)"  />.
          </div>
          <p class="p--slide">{{ card.name }}</p>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';
import FirebaseHelper from '@/service/FirebaseHelper';
import { mapGetters } from "vuex";

export default {
  components: {
    Carousel,
    Slide,
  },
  props: {
    titulo: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      plano: "plano",
      statusParticipacao: "statusParticipacao",
      isRP: "isRP"
    }),
  },
  data() {
    return {
      firebaseHelper: new FirebaseHelper(),
      cardsAcessoRapido: null,
      perPage: 4.5,
      listaCards: [],
      osType: false
    };
  },
  async created() {
    this.cardsAcessoRapido = await this.firebaseHelper.getCardsAcessoRapido(this.plano);
    if (!this.isRP) {
      this.cardsAcessoRapido = this.cardsAcessoRapido.filter(card => card.name !== 'RP');
    }
    if (this.statusParticipacao === 'Assistido') {
      this.cardsAcessoRapido.forEach(card => {
        if (card.name === 'Minhas Contribuições') {
          card.name = 'Meus Recebimentos';
          card.link = '/historicorecebimento';
        }
      });
      this.cardsAcessoRapido = this.cardsAcessoRapido.filter(card => card.name !== 'Mais Amigos');
    }

    if (this.statusParticipacao === 'Novo') {
      this.cardsAcessoRapido = this.cardsAcessoRapido.filter(card => card.name !== 'Meu Saldo' && card.name !== 'Meu Extrato');
    }

    this.perPage = this.cardsAcessoRapido.length > 3.5 ? 4.5 : this.cardsAcessoRapido.length;

    if (window.screen.width < 500) {
      this.perPage = 4.5;
    }

    this.listaCards = this.cardsAcessoRapidoPersonalizado && this.cardsAcessoRapidoPersonalizado.length > 0
      ? this.cardsAcessoRapidoPersonalizado
      : this.cardsAcessoRapido;
  },
  mounted() {
    this.detectOS()
  },
  methods: {
    detectOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/windows phone/i.test(userAgent)) {
        this.osType = 'Windows Phone';
      } else if (/windows/i.test(userAgent)) {
        this.osType = 'Windows';
      } else if (/android/i.test(userAgent)) {
        this.osType = 'Android';
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.osType = 'iOS';
      } else if (/mac/i.test(userAgent)) {
        this.osType = 'macOS';
      } else {
        this.osType = 'Outro sistema operacional';
      }
    },
    acessar(link) {
      this.$router.push(link);
    },
    imageUrl(imagePath) {

      if (this.osType === 'iOS') {

        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        const port = window.location.port ? `:${window.location.port}` : ''; // Adiciona a porta apenas se existir
        const baseUrl = hostname === 'localhost'
          ? `${protocol}//${hostname}${port}` // URL para desenvolvimento local com porta dinâmica
          : 'https://maisfuturo.previdenciadigital.com.br'; // URL para produção

        return `${baseUrl}/${imagePath}`;

      } else {
      
        return `${imagePath}`;
      }
    }
  }
};
</script>

<style scoped>
/* Container */
.p--acessoRapido__titulo {
  font-weight: bold;
  margin: 7px 0;
  font-size: 12px;
  line-height: 17px;
}

/* Slider: Imagem */
.box-image--acessoRapido {
  height: 90px;
  width: 90px;
  margin-left: 0; /* Remove margem lateral para aproximar as imagens */
  margin-right: 0; /* Remove margem lateral para aproximar as imagens */
  opacity: 1;
  background-color: #e9e9e9;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dbdbdb;
  margin-bottom: 5px; /* Adiciona espaço para garantir alinhamento */
}

.slide__img--acessoRapido {
  height: 55px;
  transition: .5s ease;
  backface-visibility: hidden;
  object-fit: cover;
}

.box-image--acessoRapido:hover .slide__img--acessoRapido {
  opacity: 0.3;
}

/* Texto do slide */
.p--slide {
  font-size: 10px;
  line-height: 12px;
  margin-top: 5px;
  text-align: center;
  height: 24px; /* Altura para duas linhas de texto */
  overflow: hidden; /* Esconde o excesso de texto */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Contêiner principal para alinhamento */
.slide__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* Override da classe do componente VueCarousel */
.VueCarousel-slide {
  flex-basis: 72px; /* Reduz a largura de cada slide */
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: -20px; /* Deixa o espaçamento negativo para aproximar os slides */
  user-select: none;
  backface-visibility: hidden;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
  justify-items: center;
  display: flex;
}

@media screen and (max-width: 375px) {
  .box-image--acessoRapido {
    height: 60px;
    width: 60px;
  }
  .slide__img--acessoRapido {
    height: 35px;
  }
  .p--slide {
    font-size: 8px;
  }
}
@media (min-width: 376px) and (max-width: 475px) {
  .box-image--acessoRapido {
    height: 75px;
    width: 75px;
  }
  .slide__img--acessoRapido {
    height: 45px;
  }
}

</style>
